import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isMarketingPath, isPublicIndexablePath } from './marketingPaths';

export const MARKETING_VIEWPORT = 'width=device-width, initial-scale=1, viewport-fit=cover';
export const APP_VIEWPORT =
  'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';

export function useMarketingViewport(): void {
  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;

    const previous = meta.getAttribute('content');
    meta.setAttribute('content', MARKETING_VIEWPORT);

    return () => {
      if (previous) meta.setAttribute('content', previous);
    };
  }, []);
}

export function useAppViewport(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;
    const open = isMarketingPath(pathname) || isPublicIndexablePath(pathname);
    meta.setAttribute('content', open ? MARKETING_VIEWPORT : APP_VIEWPORT);
  }, [pathname]);
}
